import * as React from 'react'
import { Link } from 'DVWebNodeUI'
import { NavLink } from 'DVWebNodeUtils'

export interface MenuProps {
  text: string,
  links: NavLink[]
}

export const MainMenu = ({text, links}: MenuProps) => {
  const listItems = links.map((linkProps, i) => (
    <li key={i}>
      <Link {...linkProps}
        className={linkProps.isHighlighted ? 'pv-highlighted' : ''}
        key={linkProps.text} />
    </li>
  ))
  return (
    <div id="pv-nav-main-menu" className="pv-nav-main-menu">
      <input type="checkbox" autoComplete="off" id="pv-nav-main-menu-trigger"
        className="pv-nav-main-menu-switch avu-screen-reader-only" />
      <label htmlFor="pv-nav-main-menu-trigger" className="pv-nav-main-menu-label">
        {text}
      </label>
      <ul role="navigation">
        {listItems}
      </ul>
    </div>
  )
}
